import { render, staticRenderFns } from "./HistoryBlock.vue?vue&type=template&id=915ce8d6&scoped=true"
import script from "./HistoryBlock.vue?vue&type=script&lang=js"
export * from "./HistoryBlock.vue?vue&type=script&lang=js"
import style0 from "./HistoryBlock.vue?vue&type=style&index=0&id=915ce8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915ce8d6",
  null
  
)

export default component.exports